import { render, staticRenderFns } from "./ContentfulMixinSourceLayer.vue?vue&type=template&id=0ed20707"
import script from "./ContentfulMixinSourceLayer.vue?vue&type=script&lang=js"
export * from "./ContentfulMixinSourceLayer.vue?vue&type=script&lang=js"
import style0 from "./ContentfulMixinSourceLayer.vue?vue&type=style&index=0&id=0ed20707&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports